import { Injectable, signal } from '@angular/core';

import type { IFooterSettings } from 'components/organisms/footer/entities/types';

import type { IMenuItem, THeaderType } from '../entities/types';

@Injectable({
    providedIn: 'root',
})
export class LayoutDataService {
    private readonly headerData = signal<IMenuItem[] | null>(null);
    private readonly headerType = signal<THeaderType | null>(null);
    private readonly footerDataSignal = signal<IFooterSettings | null>(null);
    private readonly footerSecondaryDataSignal = signal<IMenuItem[] | null>(null);

    public readonly footerData = this.footerDataSignal.asReadonly();
    public readonly footerSecondaryData = this.footerSecondaryDataSignal.asReadonly();

    public setHeaderData(data: IMenuItem[] | null): void {
        this.headerData.set(data);
    }

    public getHeaderData(): IMenuItem[] | null {
        return this.headerData();
    }

    public setHeaderType(type: THeaderType | null): void {
        this.headerType.set(type);
    }

    public getHeaderType(): THeaderType | null {
        return this.headerType();
    }

    public setFooterData(data: IFooterSettings): void {
        this.footerDataSignal.set(data);
    }

    public getFooterData(): IFooterSettings | null {
        return this.footerDataSignal();
    }

    public setFooterSecondaryData(data: IMenuItem[] | null): void {
        this.footerSecondaryDataSignal.set(data);
    }

    public getFooterSecondaryData(): IMenuItem[] | null {
        return this.footerSecondaryDataSignal();
    }
}
